module.exports = {
	"articleTitle1": "Rare Botanical Garden plant to bloom for the first time in 80 years",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Agave Tequila Bar",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/03baked-buzzed-bored-spring-breakers-still-waiting-sober28",
	"articleSnippet1": "May 7, 2014 ... The Matthaei Botanical Garden is preparing to take the roof off of their \nconservatory to accommodate a twenty-foot-tall agave that will soon ...",
	"articleSnippet2": "Mar 28, 2013 ... Leather flask of 100% Agave just for kicks. After all, it's spring break (right?). No, \nit's Monday (night). My D.D. hero Brian K. drives me to the ...",
	"foodRecommendations": [],
	"articleTitle2": "Baked, Buzzed, Bored: 'Spring Breakers'",
	"address": "211 N Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.282798,
		"lng": -83.748684
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/agave.json
// module id = 802
// module chunks = 0